import React, { useEffect } from "react";
import "./index.less";
import { LightningPlusIcon } from "@/resource/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import { updateAddOrShowFavouritiesModel,
    updateCommonSuccessMessage,
    updateCommonWarnMessage,
    updateFavoriteOptions,
    updateIsClickedSearchResultButton,
    updateIsLoadingForGetSearchResult,
    updateIsRefresh,
    updateIsResetMapContentBeforeSearch,
    updateNeedClearDrawMap,
    updateNeedClearLocation,
    updateNeedClearRegion,
    updateSearchReuslt,} from "@/redux/actions/lightningAction";
import { LightningAddOrShowFavouritiesEnum, LightningSearchTypeEnum, LightningTabsEnum } from "@/util/cosntants";
import { RootState } from "@/redux/reducer/store";
import { Tabs } from "antd";
import { IGetLightningTypeContoursReqModel } from "@/util/http/Lightning/requestType";
import { getLightningTypeContours } from "@/util/http/Lightning";
import { IGetLocationsResModel } from "@/util/http/Lightning/responseType";
import { getPointsOnCircle, handleLocationSearchRequest } from "../../lightningCommonFunc";
import IF from "@/components/IF";


const LightingInvokeButton = () => {

    const dispatch = useDispatch();

    const currentTab = useSelector((state: RootState) => state.lightningReducer.currentTab);
    const searchType = useSelector((state: RootState) => state.lightningReducer.searchType);
    const isLoadingForGetSearchResult = useSelector((state: RootState) => state.lightningReducer.isLoadingForGetSearchResult);

    // for location
    const locationNameOrCoordinate = useSelector((state: RootState) => state.lightningReducer.locationNameOrCoordinate);
    const radiusValue = useSelector((state: RootState) => state.lightningReducer.radiusValue);
    const selectedLocationItem = useSelector((state: RootState) => state.lightningReducer.selectedLocationItem);
    const isGetAllUSAData = useSelector((state: RootState) => state.lightningReducer.isGetAllUSAData);
    // for region
    // TODO: need store all tree checked , expends and other's data to redux
    const finalRequestBoundaryState = useSelector((state: RootState) => state.lightningReducer.finalRequestBoundaryState);
    const finalRequestBoundaryCode = useSelector((state: RootState) => state.lightningReducer.finalRequestBoundaryCode);
    const selectedCountry = useSelector((state: RootState) => state.lightningReducer.selectedCountry);
    const autoExpandParent = useSelector((state: RootState) => state.lightningReducer?.autoExpandParent);
    const checkedKeys = useSelector((state: RootState) => state.lightningReducer?.checkedKeys);
    const selectedKeys = useSelector((state: RootState) => state.lightningReducer?.selectedKeys);
    const expandedKeys = useSelector((state: RootState) => state.lightningReducer?.expandedKeys);
    // for Draw on map
    const drawnShape = useSelector((state: RootState) => state.lightningReducer.drawnShape);
    const selectedFavoritiesInformation = useSelector((state: RootState) => state.lightningReducer?.selectedFavoritiesInfo);
    const detectedRadius = useSelector((state: RootState) => state.lightningReducer?.detectedRadius);
    const tolerance = useSelector((state: RootState) => state.lightningReducer?.tolerance);
    const isFresh = useSelector((state: RootState) => state.lightningReducer?.isFresh);


    const publicHandleAddFavourities = () => {
        let tmpFlag = false;
        let tmpOptions = {};
        if (currentTab === LightningTabsEnum.LOCATION) {
            if( locationNameOrCoordinate && radiusValue >= 0) {
                tmpFlag = true;
                tmpOptions = {
                    locationNameOrCoordinate: locationNameOrCoordinate,
                    radiusValue: radiusValue,
                    selectedLocationItem: selectedLocationItem,
                    currentTab:LightningTabsEnum.LOCATION,
                };
            }
        } else if (currentTab === LightningTabsEnum.Region) {
            if(finalRequestBoundaryState && finalRequestBoundaryState.length > 0) {
                tmpFlag = true;
                tmpOptions = {
                    finalRequestBoundaryState: finalRequestBoundaryState,
                    finalRequestBoundaryCode: finalRequestBoundaryCode,
                    selectedCountry:selectedCountry,
                    expandedKeys:expandedKeys,
                    checkedKeys:checkedKeys,
                    selectedKeys:selectedKeys,
                    autoExpandParent:autoExpandParent,
                    currentTab:LightningTabsEnum.Region,
                };
            }
        } else if (currentTab === LightningTabsEnum.DRAWONMAP) {
            if(drawnShape) {
                tmpFlag = true;
                tmpOptions = {
                    drawnShape: drawnShape,
                    currentTab:LightningTabsEnum.DRAWONMAP,
                };
            }
        }

        // operation for add to favourities
        if (tmpFlag) {
            dispatch(updateFavoriteOptions(tmpOptions));
            // dispatch(updateSelectedFavoriteInfo(tmpOptions));
            dispatch(updateAddOrShowFavouritiesModel(LightningAddOrShowFavouritiesEnum.ADD));
        }
        else{
            dispatch(updateCommonWarnMessage("Please input madatory data."));
        }
    };

    const clearDatas =()=>{
        //For location
        dispatch(updateNeedClearLocation(true));
        //for region
        dispatch(updateNeedClearRegion(true));
        //for drawonmap
        dispatch(updateNeedClearDrawMap(true));

        // reset search Result button's status
        dispatch(updateIsClickedSearchResultButton(false));
    };

    const slefSleep = (ms: number) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    };
    const blockForOneSecond = async () => {
        await slefSleep(1000); // 模拟阻塞1秒
    };

    // for search result
    const publicHandleSearchResult = async() => {
        let tmpFlag = false;
        const requestOptions:IGetLightningTypeContoursReqModel = {
            lightningType: searchType,
            radius: searchType === LightningSearchTypeEnum.DETECTED ? detectedRadius : undefined, // 只有 DETECTED 需要 radius
            tolerance: searchType === LightningSearchTypeEnum.DETECTED ? tolerance : undefined, // 只有 DETECTED 需要 radius
            isReplot: searchType === LightningSearchTypeEnum.DETECTED ? false : true, // 只有 DETECTED 需要 isReplot
        };

        if (currentTab === LightningTabsEnum.LOCATION) {
            if(locationNameOrCoordinate && radiusValue >= 0) {
                tmpFlag = true;
                const [longitude, latitude] = handleLocationSearchRequest(locationNameOrCoordinate, selectedLocationItem);
                requestOptions.areas = null;
                requestOptions.geometries = [
                    {
                        type: "Point",
                        properties: {
                            radius: radiusValue,
                        },
                        coordinates: [longitude, latitude]
                    }
                ];

            }

        } else if (currentTab === LightningTabsEnum.Region) {
            if(finalRequestBoundaryCode && finalRequestBoundaryCode.length > 0) {
                tmpFlag = true;
                // requestOptions.areas = finalRequestBoundaryState;
                requestOptions.areas = finalRequestBoundaryCode;
            }
        } else if (currentTab === LightningTabsEnum.DRAWONMAP) {
            if(drawnShape) {
                tmpFlag = true;
                requestOptions.areas = null;
                requestOptions.geometries = [];
                if(drawnShape.type === "polygon"){
                    const tmpCoordinates = drawnShape.data.map(item => {
                        return [
                            item.lng,
                            item.lat,
                        ];
                    });
                    tmpCoordinates.push(tmpCoordinates[0]);
                    requestOptions.geometries = [{
                        type: "Polygon",
                        properties: {
                            radius: null
                        },
                        coordinates: [tmpCoordinates]
                    }];
                }
                else if(drawnShape.type === "circle"){
                    const circlePoints = getPointsOnCircle(drawnShape.data.lat, drawnShape.data.lng, drawnShape.data.radiusKm, 12);

                    const tmpCoordinates = circlePoints?.map(item => {
                        return [
                            item.lng,
                            item.lat,
                        ];
                    });
                    tmpCoordinates.push(tmpCoordinates[0]);
                    requestOptions.geometries = [{
                        type: "Polygon",
                        properties: {
                            radius: drawnShape?.data?.radiusKm
                        },
                        coordinates: [tmpCoordinates]
                    }];
                }
            }
            console.log("Add to Favourities with coordinate:", locationNameOrCoordinate, radiusValue);
        }

        // operation for add to favourities
        if (tmpFlag) {
            try{
                dispatch(updateIsResetMapContentBeforeSearch(true));
                dispatch(updateSearchReuslt(null));
                // 等待一个微任务，确保重置逻辑完成
                await Promise.resolve();
                dispatch(updateIsLoadingForGetSearchResult(true));
                const res = await getLightningTypeContours(requestOptions);
                console.log("Search Result:", res?.data);
                if(res?.data && res?.data?.features){
                    if(res.data.features.length > 0){
                        // dispatch(updateCommonSuccessMessage("Successfully get Risk data."));
                        await blockForOneSecond(); // 模拟阻塞1秒
                        dispatch(updateSearchReuslt(res?.data));
                    }
                    else{
                        dispatch(updateCommonSuccessMessage(publicHandelErrorMessage()));
                    }
                }
            }
            catch (error) {
                console.error("Error fetching lightning type contours:", error);
                dispatch(updateCommonWarnMessage(publicHandleErrorRequestMessage()));
            }
            finally{
                dispatch(updateIsLoadingForGetSearchResult(false));
                dispatch(updateIsClickedSearchResultButton(true));
            }
        }
        else{
            dispatch(updateCommonWarnMessage("Please input madatory data."));
        }
    };

    const publicHandleErrorRequestMessage = ()=>{
        let tmpMessage = "";
        switch (searchType) {
            case LightningSearchTypeEnum.FIRSTSTRIKE:
                tmpMessage = "Failed to get First Strike data.";
                break;
            case LightningSearchTypeEnum.DETECTED:
                tmpMessage = "Failed to get Detected Strike data.";
                break;
            case LightningSearchTypeEnum.PROBABILITY:
                tmpMessage = "Failed to get Probability Strike data.";
                break;
            case LightningSearchTypeEnum.ALLCLEAR:
                tmpMessage = "Failed to get Risk data.";
                break;
        }
        return tmpMessage;
    };
    const publicHandelErrorMessage = ()=>{
        let tmpMessage = "";
        if(currentTab === LightningTabsEnum.LOCATION){
            switch (searchType) {
                case LightningSearchTypeEnum.FIRSTSTRIKE:
                    tmpMessage = "No  data for first strike for selected location/coordinate for next 1 hour.";
                    break;
                case LightningSearchTypeEnum.DETECTED:
                    tmpMessage = "No detected strike for selected location/coordinate.";
                    break;
                case LightningSearchTypeEnum.PROBABILITY:
                    tmpMessage = "No probability is determined for selected location/coordinate.";
                    break;
                case LightningSearchTypeEnum.ALLCLEAR:
                    tmpMessage = "No data for all clear tab for selected location/coordinate.";
                    break;
            }
        }
        else if(currentTab === LightningTabsEnum.Region || currentTab === LightningTabsEnum.DRAWONMAP){
            switch (searchType) {
                case LightningSearchTypeEnum.FIRSTSTRIKE:
                    tmpMessage = "No  data for first strike for selected region for next 1 hour.";
                    break;
                case LightningSearchTypeEnum.DETECTED:
                    tmpMessage = "No detected strike for selected region.";
                    break;
                case LightningSearchTypeEnum.PROBABILITY:
                    tmpMessage = "No probability is determined for selected region.";
                    break;
                case LightningSearchTypeEnum.ALLCLEAR:
                    tmpMessage = "No data for all clear tab for selected region.";
                    break;
            }

        }
        return tmpMessage;
    };

    const publicGetAllUSAData = async() => {
        const requestOptions:IGetLightningTypeContoursReqModel = {
            lightningType: searchType,
            isReplot: searchType === LightningSearchTypeEnum.DETECTED ? false : true, // 只有 DETECTED 需要 isReplot
        };

        // operation for add to favourities
        try{
            dispatch(updateIsResetMapContentBeforeSearch(true));
            dispatch(updateSearchReuslt(null));
            // 等待一个微任务，确保重置逻辑完成
            await Promise.resolve();
            dispatch(updateIsLoadingForGetSearchResult(true));
            const res = await getLightningTypeContours(requestOptions);
            console.log("Search Result:", res?.data);
            if(res?.data && res?.data?.features){
                if(res.data.features.length > 0){
                    // dispatch(updateCommonSuccessMessage("Successfully get Risk data."));
                    await blockForOneSecond(); // 模拟阻塞1秒
                    dispatch(updateSearchReuslt(res?.data));
                }
                else{
                    dispatch(updateCommonSuccessMessage(publicHandelErrorMessage()));
                }
            }
        }
        catch (error) {
            console.error("Error fetching lightning type contours:", error);
            dispatch(updateCommonWarnMessage("Failed to get Risk data."));
        }
        finally{
            dispatch(updateIsLoadingForGetSearchResult(false));
        }
    };

    useEffect(()=>{
        if(isFresh){
            if(radiusValue === 10 && !locationNameOrCoordinate && isGetAllUSAData){
                // do nothing, because now showld get all us data
                publicGetAllUSAData();
                dispatch(updateIsRefresh(false));
            }
            else{
                publicHandleSearchResult();
                dispatch(updateIsRefresh(false));
            }

        }
    },[isFresh]);

    return (
        // <div className={`${currentTab === LightningTabsEnum.DRAWONMAP ? "button-padding-left-30": ""} lightning-invoke-button`}>
        <div className="lightning-invoke-button">
            <div className="lighting-invoke-clear-search">
                <div className="lightning-invoke-button-item clear"
                    onClick={()=>{
                        clearDatas();
                    }}>Clear</div>
                <div className="lightning-invoke-button-item search"
                    onClick={()=>{
                        publicHandleSearchResult();
                    }}
                >Search Result</div>
            </div>
            <div className="lightning-invoke-button-item favourites"
                onClick={()=>{
                    publicHandleAddFavourities();
                }}
            >
                <div className="plus-bk">
                    <LightningPlusIcon />
                </div>
                Favourities
            </div>
        </div>
    );
};

export default LightingInvokeButton;